import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _single, _TravelExpenses } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectSiteID } from "../../../../admin/configuracion/SiteID/SelectSiteID";
import { BakingEntityEditor } from "../../../../erp/cellEditor/BankingEntity/BankingEntitySelect";
import { BankingAccountEditor } from "../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/BankingAccountSelect";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { SelectConstantsValue } from "../../../../theme/Component/SelectConstantsValue";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const THV001 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_TravelExpenses);
    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            const x = configProcedure?._pocessData?.Props
            setProps(x)
            setBean({ ...bean, IDAccount: x.User, IDEmployee: _single.getAccountID(), State: 1 })
        }
    }, [configProcedure?._pocessData])

    const onExportMap = (response: any) => {
        console.log(response)
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(_single.jsonToBootstrapTable({
                "Fecha Inicial": response.FromDate,
                "Fecha Final": response.UptoDate,
                "Descripción": response.Description,
                "No Cuenta Bancaria": response.AccountBankNumber
            }))
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }
        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(response)
        }
    }

    const createTravel = () => {
        instance.updateTravelExpenses(bean).then(
            (resp) => {

                onExportMap(resp);

            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    // const validateData = () => {
    //     if (validateForm() > 0) {
    //         toast.error("Faltan campos obligatorios por completar");
    //         return;
    //     } else {

    //     }
    // }

    // const validateForm = () => {
    //     const requiredFields = [
    //         "IDLnFunctionalArea", "IDAccount", "InitContract"
    //     ];

    //     let missing = [];
    //     for (let field of requiredFields) {
    //         if (!response[field]) {
    //             missing.push(field);
    //         }
    //     }
    //     setMissingFields(missing);
    //     return missing.length
    // };


    return (
        <div className="row">
            <div className="col-md-6">
                <AccountEditor disabled={props.selectIDAccount} idAccount={bean.IDAccount} label="Solicitante" onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} />
            </div>
            <div className="col-md-6">
                <InputDate name="" value={bean.ApplicationDate} label="Fecha solicitud" setDate={(e) => { setBean({ ...bean, ApplicationDate: e }) }} />
            </div>
            <div className="col-md-6">
                <SelectSiteID edit={false} onChange={(e) => { setBean({ ...bean, Origin: e.IDLn }) }} label="Origen" />
            </div>
            <div className="col-md-6">
                <SelectSiteID edit={false} onChange={(e) => { setBean({ ...bean, Destination: e.IDLn }) }} label="Destino" />
            </div>
            <div className="col-md-6">
                <label >Tipo Pasaje</label>
                <SelectConstantsValue
                    code={24}
                    onChange={(e: any) => { setBean({ ...bean, 'PassageType': e }) }}
                    value={bean.PassageType}
                />
            </div>
            <div className="col-md-6">
                <InputDate name="" value={bean.FromDate} label="Fecha Inicial" setDate={(e) => { setBean({ ...bean, FromDate: e }) }} />
            </div>
            <div className="col-md-6">
                <InputDate name="" value={bean.UptoDate} label="Fecha Final" setDate={(e) => { setBean({ ...bean, UptoDate: e }) }} />
            </div>
            <div className="col-md-12">
                <label >Descripcion del viatico</label>
                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
            </div>
            <div className="col-6">
                <BakingEntityEditor label='Banco' idSelector={bean.IDBank} onChange={(e) => { setBean({ ...bean, "IDBank": e }) }} />
            </div>
            <div className="col-6">
                <BankingAccountEditor label='Tipo de Cuenta' idSelector={bean.AccountBankType} onChange={(e) => { setBean({ ...bean, "AccountBankType": e }) }} />
            </div>
            <div className="col-6">
                <label>No Cuenta Bancaria</label>
                <input type="text" className='form-control' value={bean.AccountBankNumber} onChange={(e) => { setBean({ ...bean, AccountBankNumber: e.target.value }) }} />
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton eventClick={createTravel} icon="ri-send-plane-line" children={`Crear`} />
            </div>
        </div>
    );
}